import React, { useEffect, useMemo, useState } from "react";
import { ActivityIndicator, Dimensions, Platform, ScrollView, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, FontTransformToken, IconSizeTokens, IconTokens, ImageSizeTokens, SizeTypeTokens } from "@voltmoney/schema";
import { ModalAlignmentEnum, SCREEN_SIZE } from '@voltmoney/types';
import { Typography } from "../../typography/Typography";
import { Icon } from "../../icon/Icon";
import { addCommasToNumber, groupByMonth, returnDateInString, returnDateInStringV2 } from "../utils";
import { TRANSACTION_TYPE } from "./type";
import { Divider } from "../../divider/Divider";
import { AppBottomNav } from "../../appBottomNav/AppBottomNav";
import BottomSheet from "../BottomSheet";
import { isMobile } from "../../stack/utils";
import { Image } from "../../image/Image";
import ThemeProvider from "@voltmoney/theme";
const TransactionPage = ({ height, data, goToEmailAction, triggerAction, navigationAction, showEmail, showOutstanding = true, emailLoading }) => {
    const [_modalData, setModalData] = useState(undefined);
    let modalContentHeight = _modalData && _modalData?.outStandingBalance ? 550 : 474;
    const [_data, setData] = useState(groupByMonth(data));
    const [modalHeight, setModalHeight] = useState((height - 76) > modalContentHeight ? modalContentHeight : height - 76);
    const [showModal, setShowModal] = useState(false);
    const [isDismissable, setDismissable] = useState(true);
    const [_showEmail, setShowEmail] = useState(showEmail);
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const getModalHeight = () => {
        let _modalContentHeight;
        if (Platform.OS === 'web') {
            _modalContentHeight = _modalData && _modalData?.outStandingBalance ? height < 570 ? height - 50 : 550 : height > 490 ? 474 : height - 70;
        }
        else {
            _modalContentHeight = _modalData && _modalData?.outStandingBalance ? height < 570 ? height - 50 : 650 : height > 510 ? 650 : height - 70;
        }
        return showOutstanding ? _modalContentHeight : modalContentHeight - 120;
    };
    useEffect(() => {
        setModalHeight(getModalHeight());
    }, [_modalData]);
    useEffect(() => {
        setData(groupByMonth(data));
    }, [data]);
    const selectTransaction = (item) => {
        setModalData(item);
        setShowModal(true);
    };
    const goToEmailScreenAction = () => {
        goToEmailAction && !emailLoading &&
            triggerAction(goToEmailAction);
    };
    const transactionPendingCard = () => (React.createElement(View, { style: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
        } },
        React.createElement(Icon, { name: IconTokens.TransactionInProgress }),
        React.createElement(View, { style: { width: 4 } }),
        React.createElement(Text, { style: {
                fontFamily: 'Inter',
                fontSize: 12,
                fontStyle: 'normal',
                fontWeight: '400',
                lineHeight: 18,
                color: '#FBC231'
            } }, "In Progress")));
    const transactionSuccessCard = () => (React.createElement(View, { style: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
        } },
        React.createElement(Icon, { name: IconTokens.TransactionSuccess, size: IconSizeTokens.LG }),
        React.createElement(View, { style: { width: 4 } }),
        React.createElement(Typography, { label: "Completed", fontWeight: "400", lineHeight: 18, fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, color: ColorTokens.System_Happy })));
    const modalContentPresenter = () => {
        const item = _modalData;
        const ListItems = [
            {
                title: 'Amount',
                value: `₹${addCommasToNumber(item.amount)}`,
                trxStatus: item?.transactionStatus
            },
            {
                title: 'Title', value: `${item.description}`
            },
            {
                title: 'Date', value: `${returnDateInStringV2(item?.settledOn)}`
            },
            {
                title: 'Type', value: `${item.transactionType}`
            },
            item?.transactionStatus === 'SETTLED'
                && showOutstanding && {
                title: 'Outstanding Balance', value: `₹${addCommasToNumber(item.outStandingBalance)}`
            },
            {
                title: 'Transaction description', value: `${item.longDescription}`
            },
        ];
        return (React.createElement(View, { style: {
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                paddingTop: 20,
            } },
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    justifyContent: 'space-between',
                    paddingHorizontal: 16,
                } },
                React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'flex-start', paddingBottom: 20 } },
                    React.createElement(View, { style: { marginRight: 16, alignContent: 'center', alignItems: 'center' } },
                        React.createElement(Icon, { name: item?.transactionType === TRANSACTION_TYPE.CREDIT ?
                                IconTokens.Credit :
                                IconTokens.Debit, size: IconSizeTokens.XXXXXL })),
                    React.createElement(View, { style: { flexDirection: 'column' } },
                        React.createElement(Typography, { label: "Transaction amount", fontSize: FontSizeTokens.XS, lineHeight: 18, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter, fontWeight: "400" }),
                        React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
                            React.createElement(Typography, { label: `₹${addCommasToNumber(item.amount)}`, fontSize: FontSizeTokens.XL, fontWeight: "600", lineHeight: 28, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter })))),
                React.createElement(View, { style: {
                        marginTop: 27,
                        paddingBottom: 20,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    } },
                    React.createElement(View, null, (item?.transactionStatus === 'SETTLED') ?
                        React.createElement(React.Fragment, null, transactionSuccessCard()) :
                        React.createElement(React.Fragment, null, transactionPendingCard())))),
            React.createElement(View, { style: {
                    backgroundColor: 'white',
                    marginBottom: 16
                } },
                React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk, margin: { horizontal: SizeTypeTokens.SIZE_MINUS_16
                    }, width: 580 })),
            React.createElement(ScrollView, { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    height: modalHeight - 50,
                    paddingHorizontal: 16,
                }, nestedScrollEnabled: true }, ListItems.map((item, index) => (React.createElement(React.Fragment, null, React.createElement(React.Fragment, null,
                item?.value &&
                    item?.title &&
                    React.createElement(View, { style: {
                            paddingTop: index === 0 ? 0 : 20,
                            paddingBottom: 20
                        } },
                        React.createElement(Typography, { label: item?.title, fontWeight: "400", fontSize: FontSizeTokens.XS, lineHeight: 18, color: ColorTokens.Grey_Charcoal }),
                        React.createElement(Typography, { label: item?.value, fontWeight: "500", fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter })),
                (index < (ListItems.length - 1)) &&
                    item?.value &&
                    item?.title &&
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Milk_1 }))))))));
    };
    const renderTransactionCards = (month, item, index, dataLength) => {
        return (React.createElement(View, { nativeID: 'txt_transactions_' + month + (index + 1), style: {
                display: 'flex',
                flexDirection: 'column',
                width: '100%'
            } },
            React.createElement(TouchableOpacity, { style: styles.transactionCardContainer, onPress: () => selectTransaction(item) },
                React.createElement(View, { style: {
                        marginRight: 12,
                    } },
                    React.createElement(Icon, { name: item?.transactionType === TRANSACTION_TYPE.CREDIT ?
                            IconTokens.Credit :
                            IconTokens.Debit, size: IconSizeTokens.XXXXXL })),
                React.createElement(View, { style: {
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                    } },
                    React.createElement(View, { style: styles.transactionTopCardContainer },
                        React.createElement(View, { style: {
                                display: 'flex',
                                flexDirection: 'row',
                                width: '100%',
                                justifyContent: 'space-between'
                            } },
                            React.createElement(Text, { style: {
                                    fontFamily: 'Inter',
                                    fontWeight: '600',
                                    lineHeight: 20,
                                    fontSize: 14,
                                    color: '#1D2939',
                                } },
                                item.description,
                                React.createElement(View, { style: {
                                        position: 'relative',
                                        top: 2,
                                        paddingLeft: 6
                                    } },
                                    React.createElement(Icon, { size: IconSizeTokens.MD, name: IconTokens.Info, color: ColorTokens.Grey_Night }))),
                            React.createElement(Typography, { label: item?.transactionType === TRANSACTION_TYPE.CREDIT ?
                                    `+ ₹${addCommasToNumber(item?.amount)}` :
                                    `- ₹${addCommasToNumber(item?.amount)}`, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, fontWeight: '600', lineHeight: 20, color: item?.transactionType === TRANSACTION_TYPE.CREDIT ?
                                    ColorTokens.Secondary_100 :
                                    ColorTokens.Grey_Night }))),
                    React.createElement(View, { style: styles.transactionBottomCardContainer },
                        React.createElement(Typography, { label: `${returnDateInString(item.settledOn)}`, fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', lineHeight: 18, color: ColorTokens.Grey_Charcoal }),
                        !showOutstanding
                            ? null
                            : item?.transactionStatus === 'SETTLED'
                                ? React.createElement(React.Fragment, null,
                                    React.createElement(Typography, { label: `Outstanding: ₹${addCommasToNumber(item?.outStandingBalance)}`, fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', lineHeight: 18, color: ColorTokens.Grey_Charcoal }))
                                : React.createElement(React.Fragment, null, transactionPendingCard())))),
            (index < (dataLength - 1)) &&
                React.createElement(View, { style: {
                        width: '100%',
                        paddingTop: 16,
                        paddingBottom: 16
                    } },
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Milk_1 }))));
    };
    const noTransactionScreen = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(View, { style: {
                    display: 'flex',
                    width: '100%',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                } },
                React.createElement(Image, { size: ImageSizeTokens.MD, uri: `https://volt-images-alpha.s3.ap-south-1.amazonaws.com/no_transactions.svg`, width: 180, height: 180 }),
                React.createElement(View, { style: { height: 24 } }),
                React.createElement(Text, { style: {
                        fontFamily: 'Poppins',
                        fontWeight: '700',
                        lineHeight: 24,
                        fontSize: 16
                    } }, "No transactions to show"))));
    };
    const renderTransactionGroupByMonth = ({ item, index }) => {
        const month = item.monthYear.split('-')[0];
        const year = item.monthYear.split('-')[1];
        return (React.createElement(View, { style: styles.groupContainer },
            React.createElement(View, { style: {
                    marginBottom: 20,
                    marginTop: index === 0 ? 0 : 34
                } },
                React.createElement(Typography, { label: `${month.toUpperCase()} ${year}`, fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Inter, fontWeight: '600', lineHeight: 18, textTransform: FontTransformToken.capitalize, color: ColorTokens.Grey_Charcoal })),
            item &&
                item.data &&
                item.data.map((eachTransactionItem, index) => renderTransactionCards(month, eachTransactionItem, index, item.data.length))));
    };
    const _headerChild = useMemo(() => {
        return (React.createElement(View, { style: {
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between'
            } },
            React.createElement(View, null,
                React.createElement(Typography, { label: 'Transactions', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, fontWeight: '700', lineHeight: 24 })),
            React.createElement(View, null, _showEmail
                && React.createElement(TouchableOpacity, { style: {
                        display: 'flex',
                        flexDirection: 'row',
                        paddingVertical: 4,
                        paddingHorizontal: 8,
                        backgroundColor: '#F3F5FC',
                        borderRadius: 24,
                        alignItems: 'center'
                    }, onPress: () => goToEmailScreenAction() },
                    React.createElement(Icon, { name: IconTokens.Email, size: IconSizeTokens.XL, color: ColorTokens.Primary_100 }),
                    React.createElement(View, { nativeID: "txt_transactions_email", style: { width: 4 } }),
                    React.createElement(Typography, { label: 'Email', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XXS, fontWeight: '500', lineHeight: 16, color: ColorTokens.Primary_100 }),
                    React.createElement(View, { style: { width: 8 } }),
                    emailLoading && React.createElement(ActivityIndicator, { color: colorMapping[ColorTokens.Primary_100], size: 8 })))));
    }, [emailLoading]);
    const _bodyChild = useMemo(() => {
        return (React.createElement(React.Fragment, null, _data &&
            _data.length === 0 ?
            noTransactionScreen() :
            React.createElement(ScrollView, { style: {
                    height: '100%',
                    paddingBottom: 16,
                    paddingHorizontal: 16,
                    marginBottom: Platform.OS === 'ios' ? 42 : 0,
                } },
                React.createElement(View, { style: { height: 16 } }),
                _data &&
                    _data.map((item, index) => renderTransactionGroupByMonth({ item, index })),
                React.createElement(View, { style: { height: 16 } }))));
    }, [_data]);
    const _footerChild = useMemo(() => {
        return (React.createElement(View, { style: {
                width: '100%',
            } },
            React.createElement(AppBottomNav, { currentRoute: 'TRANSACTIONS', navigationAction: navigationAction, triggerAction: triggerAction })));
    }, []);
    return (React.createElement(View, { style: [
            styles.container,
            { height: height }
        ] },
        React.createElement(View, { style: {
                flex: 1
            } },
            React.createElement(View, { style: styles.header }, _headerChild),
            React.createElement(View, { style: [styles.body, { height: height - 138 }] }, _bodyChild),
            React.createElement(View, { style: styles.footer }, _footerChild)),
        showModal &&
            React.createElement(View, { style: {
                    bottom: 0,
                    position: 'absolute'
                } },
                React.createElement(BottomSheet, { id: "bt_transactions_cancel", autoAdjustHeight: false, height: modalHeight, width: '100%', closeFunction: () => setShowModal(false), alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: isDismissable, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Platform.OS !== "ios" ? Dimensions.get('window').height : Dimensions.get('window').height + 5 : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true }, modalContentPresenter()))));
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
// @ts-ignore
const styles = StyleSheet.create({
    container: {
        width: '100%',
    },
    header: {
        marginTop: Platform.OS === 'ios' ? 34 : 0,
        paddingHorizontal: 16,
        paddingTop: 12,
        paddingBottom: 12,
        borderBottomWidth: 1,
        borderBottomColor: '#F1F3F5',
        backgroundColor: '#FFF',
        height: 66,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    body: {},
    footer: {
        position: 'absolute',
        paddingBottom: Platform.OS === "ios" ? 12 : 0,
        bottom: 0,
        zIndex: 99,
        width: '100%',
        // backgroundColor: '#FFF',
        borderWidth: 1,
        borderColor: '#F1F3F5',
        backgroundColor: 'rgb(255, 255, 255)',
        shadowColor: 'rgba(0, 0, 0, 0.2)',
        shadowOffset: {
            width: 0,
            height: -1,
        },
        shadowOpacity: 0.5,
    },
    groupContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    transactionCardContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between',
    },
    transactionTopCardContainer: {
        display: 'flex',
        flexDirection: 'row',
        paddingBottom: 2,
    },
    transactionBottomCardContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: "space-between"
    },
});
export default (TransactionPage);
